import { NumericConstants } from './constants'
import i18n from '@/i18n'
import { sumBy, maxBy, cloneDeep } from 'lodash'

const NUM_DECIMALS_TONS_MBF = 3

export function tonStringFromPounds (x, numberOfDecimals = NUM_DECIMALS_TONS_MBF, isMetric = false) {
  const asFloat = parseFloat(x)
  if (isNaN(asFloat) || typeof (asFloat) !== 'number') {
    return '0'
  }

  const divisor = isMetric ? NumericConstants.MetricTonDivisor : NumericConstants.ShortTonDivisor
  const tons = (x / divisor).toFixed(numberOfDecimals)

  return numberWithCommas(tons, 3)
}

export function mbfStringFromBf (x, numberOfDecimals = NUM_DECIMALS_TONS_MBF) {
  const asFloat = parseFloat(x)
  if (isNaN(asFloat) || typeof (asFloat) !== 'number') {
    return '0'
  }

  const divisor = NumericConstants.MbfDivisor
  const mbf = (x / divisor).toFixed(numberOfDecimals)

  return numberWithCommas(mbf, 3)
}

export function effectiveRatePerMbf (amount, netVolumeInBf) {
  if (!netVolumeInBf) return null
  return amount / (netVolumeInBf / NumericConstants.MbfDivisor)
}

export function numberWithCommas (x, numberOfDecimals) {
  const asFloat = parseFloat(x)
  if (isNaN(asFloat) || typeof (asFloat) !== 'number') {
    return '0'
  }

  const toFixed = asFloat.toFixed(numberOfDecimals || 0)

  const split = toFixed.split('.')
  const preDecimal = split[0]
  const postDecimal = split[1]

  let result = preDecimal.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  if (postDecimal) {
    result = result.concat(`.${postDecimal}`)
  }
  return result
}

export function pageRangeString (firstPage, lastPage) {
  return firstPage === lastPage
    ? numberWithCommas(firstPage)
    : `${numberWithCommas(firstPage)} - ${numberWithCommas(lastPage)}`
}

export function formatMoney (value) {
  if (isNaN(value) || typeof (value) !== 'number') {
    return '$0.00'
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    currencySign: 'accounting',
    minimumFractionDigits: 2
  })

  return formatter.format(value)
}

export function getFormattedTons (weight) {
  const tons = (weight / NumericConstants.ShortTonDivisor).toFixed(3)
  return numberWithCommas(tons, 3)
}

export const uuidv4 = () => ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))

export function getFormattedCoord (coordinate) {
  return parseFloat(getFormattedCoordWithTrailingZeroes(coordinate))
}

export function getFormattedCoordWithTrailingZeroes (coordinate) {
  return parseFloat(coordinate).toFixed(6)
}

export function formatPercentage (percent) {
  const asFloat = parseFloat(percent)
  if (isNaN(asFloat) || typeof (asFloat) !== 'number') {
    return '0%'
  }
  return `${asFloat.toFixed(2)}%`
}

export function convertToPercentage (quotient, decimalPlaces, floor = false) {
  const asFloat = parseFloat(quotient)
  if (isNaN(asFloat) || typeof (asFloat) !== 'number') {
    return i18n.$t('notApplicable')
  }

  return `${floor ? Math.floor(asFloat * 100) : (asFloat * 100).toFixed(decimalPlaces)}%`
}

export function poundsToTons (pounds) {
  const tons = (pounds / 2000).toFixed(3)
  return parseFloat(tons)
}

export function correctPercentagesToOneHundred (objectsWithPercentages, percentageKey) {
  if (objectsWithPercentages.every(o => o[percentageKey] == null)) {
    return objectsWithPercentages
  }
  const objects = cloneDeep(objectsWithPercentages)
  const sum = sumBy(objects, o => o[percentageKey] || 0)
  const difference = 100.000 - sum
  if (difference === 0.000) {
    return objectsWithPercentages
  }
  const max = maxBy(objects, o => o[percentageKey] || 0)
  max[percentageKey] += difference
  return objects
}
